export default __webpack_public_path__ + "static/media/energy-genius-chart.3a79fbe1.png";